import Image, { StaticImageData } from 'next/image';
import React, { FC, Fragment, ReactNode } from 'react';
import styled from 'styled-components';
import { ContentBanner } from '../ContentBanner/ContentBanner';

export interface IExtraContent {
  title: string;
  description: ReactNode;
  image?: StaticImageData;
  list?: { title: string; description: string }[];
  items: { title: string; description: ReactNode; image?: StaticImageData }[];
  footerText?: string;
  banner?: {
    title: string;
    description: string;
    withButton?: boolean;
    bookServiceButton?: boolean;
  };
}

interface IProps {
  data: IExtraContent[];
}

export const ExtraContent: FC<IProps> = ({ data }) => {
  return (
    <>
      {data.map((section) => {
        const { title, description, items, footerText } = section;

        return (
          <Wrapper key={section.title}>
            <h2 className="mb-6 text-left text-4xl font-semibold">{title}</h2>

            {!!section.image && (
              <div className="mx-auto my-8 max-w-[400px] overflow-hidden rounded-[16px]">
                <Image src={section.image} alt="money" />
              </div>
            )}

            {description && (
              <p
                className="description-with-links mb-6"
                dangerouslySetInnerHTML={{ __html: description as string }}
              />
            )}

            {!!section.list?.length && (
              <ul className="mb-10 ml-6 flex w-full list-disc flex-col gap-y-1.5">
                {section.list.map((listItem) => (
                  <li
                    key={listItem.title}
                    className="mb-4 text-left text-base font-normal"
                  >
                    {listItem.title && (
                      <span className="font-semibold">{listItem.title}</span>
                    )}{' '}
                    {listItem.description && (
                      <span
                        className="description-with-links"
                        dangerouslySetInnerHTML={{
                          __html: listItem.description,
                        }}
                      />
                    )}
                  </li>
                ))}
              </ul>
            )}

            {items.map((item) => (
              <Block key={item.title}>
                {!!item.image && (
                  <ImageWrapper className="max-w-[100px] overflow-hidden rounded-[16px]">
                    <Image src={item.image} alt="money" />
                  </ImageWrapper>
                )}

                <div>
                  <h3 className="mb-1 text-2xl">{item.title}</h3>
                  {typeof item.description === 'string' ? (
                    <p
                      className="description-with-links"
                      dangerouslySetInnerHTML={{
                        __html: item.description,
                      }}
                    />
                  ) : (
                    <p className="description-with-links">{item.description}</p>
                  )}
                </div>
              </Block>
            ))}

            <p
              className="description-with-links my-6"
              dangerouslySetInnerHTML={{ __html: footerText as string }}
            />

            {section.banner?.title && (
              <div className="mt-24">
                <ContentBanner
                  title={section.banner?.title}
                  description={section.banner?.description}
                  withButton={!!section.banner?.withButton}
                  bookServiceButton={!!section.banner?.bookServiceButton}
                />
              </div>
            )}
          </Wrapper>
        );
      })}
    </>
  );
};

const Wrapper = styled.div`
  text-align: left;
  /* margin-bottom: 6rem; */

  a {
    text-decoration: underline;
  }
`;

const ImageWrapper = styled.div``;

const Block = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
  margin-top: 40px;

  @media (max-width: 550px) {
    flex-direction: column;
  }
`;
